<template>
  <div class="Configuration-level-main">
    <div class="Configuration-level-center">
      <div class="content-center">
        <div class="tab" :class="{'tab-just': timeTabList.length === 6}" v-show="innerWidth > 799">
          <div 
            class="tab-item" 
            v-for="item in timeTabList" 
            :key="item.id" 
            :class="{'tabActive': timeSelectedId == item.id}" 
            @click="timeTabClick(item.id)">
            <div class="tab-item-title">
              {{ item.title }}
            </div>
          </div>
        </div>
        <div class="tab" :class="{'tab-position': innerWidth <= 799}" v-show="innerWidth <= 799">
            <div class="tab-input" @click="isShow = !isShow">
              <div class="tab-input-text">{{tabVal}}</div>
              <img src="../../../static/img/bookNow/icon.png" alt="" :style="{ transform: isShow ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.8s ease-in-out',}">
            </div>
            <selectComponent :id="0" :options="timeTabList" v-if="isShow" @fatherSelectItem="childSelectItem"/>
        </div>

        <!-- Fade transition for content change -->
        <transition name="fade" mode="out-in">
          <div 
            class="content-center-tab-content" 
            :key="timeSelectedId"
            >
            <div class="time">
              <div class="include">
                Tourist attractions include
              </div>
              <div class="location-list">
                <div class="location-item" v-for="item in locationList" :key="item.id">
                  <div class="location-item-title">
                    {{ item.name }}
                  </div>
                  <div class="location-item-content">
                    <span 
                      class="location-item-content-item" 
                      v-for="(content, index) in item.content" 
                      :key="content">
                      {{ content }} <span class="border-span" v-if="index !== item.content.length - 1">|</span>
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div class="level">
              <div class="level-tab" v-if="levelTabList.length > 0">
                <div 
                  class="level-tab-item" 
                  v-for="item in levelTabList" 
                  :key="item.id" 
                  @click="levelTabClick(item.id)" 
                  :class="{'level-tab-item-active': levelSelectedId === item.id}">
                  <div class="level-tab-item-title">
                    {{ item.title }}
                  </div>
                </div>
              </div>
            </div>
            <transition name="fade" mode="out-in">
               <div class="server-content-center" :key="levelSelectedId">
                    <div class="server" v-if="serverList.length > 0">
                        <div class="server-item" v-for="item in serverList" :key="item.id">
                            <div class="server-item-title">
                            {{ item.title }}
                            </div>
                            <div class="all-desc">
                            <span 
                                class="server-item-desc" 
                                v-for="(desc, index) in item.descList" 
                                :key="desc">
                                {{ desc }}<span class="border-span" v-if="index !== item.descList.length - 1">|</span>
                            </span>
                            </div>
                        </div>
                    </div>

                    <div class="Tourist">
                    <div class="Tourist-title">
                        Tourist attractions include
                    </div>
                    <swiperComponent
                        v-show="innerWidth > 799" 
                        :type="1" 
                        :swiperList="swiperList" 
                        @childSlideEvent="fatherSlideClickEvent" 
                        v-if="swiperList.length > 0">
                    </swiperComponent>
                    <swiperComponentPhone
                        v-show="innerWidth <= 799" 
                        :type="1" 
                        :swiperList="swiperList" 
                        @childSlideEvent="fatherSlideClickEvent" 
                        v-if="swiperList.length > 0">
                    </swiperComponentPhone>
                    </div>

                    <div class="price">
                        <div class="price-title">
                            Total reference price
                        </div>
                        <div class="price-num">
                            From RAM 25000
                        </div>
                    </div>
               </div>
            </transition>
          </div>
        </transition>
      </div>
    </div>

    <maskSwiper 
      :swiperList="swiperList" 
      @childCloseEvent="fatherCloseEvent" 
      :swiperIndex="swiperIndex" 
      :widthId="3" 
      v-if="isMask">
    </maskSwiper>
  </div>
</template>

<script>
import maskSwiper from '/components/pc/productDetailsSwiper/maskSwiper/maskSwiper.vue'
import swiperComponent from '/components/pc/productContentComponent/swiperComponent/swiperComponent.vue'
import swiperComponentPhone from '/components/phone/productContentComponent/swiperComponent/swiperComponent.vue'
// import loopSwiper from '/components/pc/productDetailsSwiper/loopSwiper/loopSwiper.vue'
import configurationLevelInfo from '/js/newProductDetils/configurationLevelInfo.js'
import selectComponent from '/components/pc/fromComponent/selectComponent/selectComponent.vue'
    export default{
        components:{
            maskSwiper,
            swiperComponent,
            selectComponent,
            swiperComponentPhone,
            // loopSwiper
        },
        props:{
            viewportWidth:String,
        },
        data(){
            return {
                timeTabList:[],//旅游时间选项
                configurationLevelList:[],//所有数据
                timeSelectedId:1,//当前旅游时间选项
                locationList:[],//当前旅游时间包含每个地方具体有哪些景点
                levelTabList:[],//当前旅游时间包含普通、高端等级选项
                levelListInfo:{},//当前旅游时间包含级别所有数据
                levelSelectedId:1,//当前旅游时间包含普通、高端等级选项
                allServerListList:[],//不同旅游时间包含的服务
                serverList:[],//不同旅游时间、等级包含服务具体内容
                swiperList:[],//不同旅游时间、等级包含服务具体内容轮播图
                isMask:false,//是否显示轮播图
                swiperIndex:0,//轮播图索引
                routerId:0,
                isShow:false,
                innerWidth:0,
                tabVal:'',
            }
        },
        created(){
            this.routerId = this.$route.query.id
             configurationLevelInfo.configurationLevelInfo.map(item=>{
                if(item.id == this.routerId){
                   this.timeTabList = item.timeTabList
                }
            })
            // this.timeTabList = configurationLevelInfo.configurationLevelInfo[this.routerId - 1].timeTabList//几日游选项
            // this.configurationLevelList = configurationLevelInfo.configurationLevelInfo[this.routerId - 1].list//所有数据
            configurationLevelInfo.configurationLevelInfo.map(item=>{
                if(item.id == this.routerId){
                    this.configurationLevelList = item.list
                }
            })
        },
        mounted(){
            this.locationList = this.configurationLevelList[0].positionList//每个地方具体有哪些景点
            this.levelListInfo = this.configurationLevelList[0].levelListInfo//级别所有数据
            if(JSON.stringify(this.levelListInfo) == '{}'){
                this.levelTabList = []
                this.serverList = []
                this.allServerListList = []
            }else{
                this.levelTabList = this.levelListInfo.levelTabList//普通、高端等级选项
                this.allServerListList = this.levelListInfo.allServerListList//所有的服务数据
                this.serverList = this.allServerListList[0].serverList//不同旅游时间包含服务具体内容
                this.swiperList = this.allServerListList[0].swiperList//不同旅游时间包含服务轮播
            }
            this.tabVal = this.timeTabList[0].title
            this.timeSelectedId = this.timeTabList[0].id
        },
        watch:{
          viewportWidth:{
            handler(newVal){
                this.innerWidth = newVal
            },
            immediate:true,
            deep:true
          }
        },
        methods:{
          childSelectItem(item){
            this.tabVal = item.title
            this.isShow = false
            this.timeTabList.map(item=>{
              if(item.title == this.tabVal){
                this.timeSelectedId = item.id
              }
            })
            this.timeTabClick(this.timeSelectedId)
          },
          timeTabClick(id){
              this.timeSelectedId = id
              this.configurationLevelList.map(item=>{
                  if(item.id == this.timeSelectedId){
                      this.locationList = item.positionList//不同旅游时间包含每个地方具体有哪些景点
                      this.levelListInfo = item.levelListInfo//不同旅游时间包含级别所有数据
                  }
              })
              if(JSON.stringify(this.levelListInfo) == '{}'){
                  this.levelTabList = []
                  this.allServerListList = []
                  this.serverList = []
                  this.swiperList = []
              }else{
                  this.levelTabList = this.levelListInfo.levelTabList//普通、高端等级选项
                  this.allServerListList = this.levelListInfo.allServerListList//所有的服务数据
                  // 切换时间需要判断---等级选项选
                  if(this.allServerListList.length > 0){
                          this.allServerListList.map(item=>{
                          if(item.id == this.levelSelectedId){
                              this.serverList = item.serverList
                              this.swiperList = item.swiperList
                          }
                      })
                  }else{
                      this.serverList = []
                      this.swiperList = []
                  }
              } 
            },
            levelTabClick(id){
                this.levelSelectedId = id
                if(this.allServerListList.length > 0){
                        this.allServerListList.map(item=>{
                        if(item.id == this.levelSelectedId){
                            this.serverList = item.serverList
                            this.swiperList = item.swiperList
                        }
                    })
                }else{
                    this.serverList = []
                    this.swiperList = []
                }
                
            },
            // 关闭弹窗轮播
             fatherCloseEvent(val){
                this.isMask = val
            },
            // 弹窗轮播
            fatherSlideClickEvent(id){
                this.isMask = true
                this.swiperIndex = id- 1
            }
        }
    }
</script>
<style scoped lang="scss">
    @import '/style/pc/newProductDetails/configurationLevel.scss';
    @import '/style/phone/newProductDetils/configurationLevel.scss';
    // @import '/style/pc/common/fadeIn.scss';
    /* Fade-in animation */
/* 过渡效果 */
.fade-enter-active, .fade-leave-active {
  transition: opacity 1s ease-in-out;
}

.fade-enter, .fade-leave-to /* 兼容 Vue 2.x 版本 */ {
  opacity: 0;
}
</style>